import React from "react";
import { useHistory } from "react-router-dom";
// @material-ui/core components
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Divider from "@material-ui/core/Divider";
import Hidden from "@material-ui/core/Hidden";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Typography from "@material-ui/core/Typography";
// @material-ui/icons components
import DirectionsRun from "@material-ui/icons/DirectionsRun";
import Person from "@material-ui/icons/Person";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

// core components
import componentStyles from "assets/theme/components/dropdowns/user-dropdown.js";
import componentStylesGeneric from "assets/theme/views/admin/generic";
import { checkOperationPermission } from "utils/permission";
import { OPERATIONS } from "utils/const";

//Redux
import { connect } from "react-redux";
import logoutAction from "redux/actions/auth/logoutAction";
import { getNameInitials } from "utils/converters";

const useStyles = makeStyles(componentStyles);
const useStylesGeneric = makeStyles(componentStylesGeneric);

function UserDropdown(props) {
  const theme = useTheme();
  const classes = { ...useStylesGeneric(), ...useStyles() };
  const [anchorEl, setAnchorEl] = React.useState(null);
  const history = useHistory();

  const isMenuOpen = Boolean(anchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    props.logoutAction();
    setAnchorEl(null);
  };

  const getUserFullName = () => {
    return (props.authState?.name ?? "") + " " + (props.authState?.lastName ?? "")
  };

  const menuId = "dropdowns-user-dropdown-id";
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      id={menuId}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <Typography
        variant="h6"
        component="h6"
        classes={{ root: classes.menuTitle }}
      >
        Bem-vindo!
      </Typography>
      
      <Divider component="div" classes={{ root: classes.dividerRoot }} />

      <Box component={Grid} display={"flex"} flexDirection={"column"}>
        <Box
          component={MenuItem}
          padding=".5rem 1rem"
          color={theme.palette.black.main}
          onClick={() => {
            handleMenuClose();
            history.push(props.authState.userType === 1 ? "/admin/personal-profile" : "/admin/user-profile");
          }}
          className={classes.nestedItem}
        >
          <Box
            component={Person}
            color={theme.palette.black.main}
            width="1.25rem!important"
            height="1.25rem!important"
            marginRight="1rem"
          />
          <span>Meu perfil</span>
        </Box>

        {checkOperationPermission(props.authState.operationsList, OPERATIONS.APPLICATIONS_FOLLOWUP_LIST_ITEM_USER_COLECTIVE) && (
          <Box
            component={MenuItem}
            padding=".5rem 1rem"
            color={theme.palette.black.main}
            onClick={() => {
              handleMenuClose();
              history.push("/admin/my-candidates-followup");
            }}
            className={classes.nestedItem}
          >
            <Box
              component={Person}
              color={theme.palette.black.main}
              width="1.25rem!important"
              height="1.25rem!important"
              marginRight="1rem"
            />
            <span>Acompanhamentos</span>
          </Box>
        )}
        {checkOperationPermission(props.authState.operationsList, OPERATIONS.APPLICATIONS_FOLLOWUP_LIST_ITEM_USER_COLECTIVE) && (
          <Box
            component={MenuItem}
            padding=".5rem 1rem"
            color={theme.palette.black.main}
            onClick={() => {
              handleMenuClose();
              history.push("/admin/my-benefits");
            }}
            className={classes.nestedItem}
          >
            <Box
              component={Person}
              color={theme.palette.black.main}
              width="1.25rem!important"
              height="1.25rem!important"
              marginRight="1rem"
            />
            <span>Benefícios Recebidos</span>
          </Box>
        )}
        {(checkOperationPermission(props.authState.operationsList, OPERATIONS.APPLICATIONS_LIST_ITEM_USER_SINGULAR) || checkOperationPermission(props.authState.operationsList, OPERATIONS.APPLICATIONS_LIST_ITEM_USER_COLECTIVE)) && (
          <Box
            component={MenuItem}
            padding=".5rem 1rem"
            color={theme.palette.black.main}
            onClick={() => {
              handleMenuClose();
              history.push("/admin/my-applications");
            }}
            className={classes.nestedItem}
          >
            <Box
              component={Person}
              color={theme.palette.black.main}
              width="1.25rem!important"
              height="1.25rem!important"
              marginRight="1rem"
            />
            <span>Minhas Candidaturas</span>
          </Box>
        )}
        {checkOperationPermission(props.authState.operationsList, OPERATIONS.APPLICATIONS_FOLLOWUP_LIST_ITEM_USER_SINGULAR) && (
          <Box
            component={MenuItem}
            padding=".5rem 1rem"
            color={theme.palette.black.main}
            onClick={() => {
              handleMenuClose();
              history.push("/admin/my-followups");
            }}
            className={classes.nestedItem}
          >
            <Box
              component={Person}
              color={theme.palette.black.main}
              width="1.25rem!important"
              height="1.25rem!important"
              marginRight="1rem"
            />
            <span>Acompanhamentos</span>
          </Box>
        )}
      </Box>

      <Divider component="div" classes={{ root: classes.dividerRoot }} />
      <Box
        display="flex!important"
        alignItems="center!important"
        component={MenuItem}
        onClick={handleLogout}
        className={classes.nestedItem}
      >
        <Box
          color={theme.palette.black.main}
          component={DirectionsRun}
          width="1.25rem!important"
          height="1.25rem!important"
          marginRight="1rem"
        />
        <span>Sair</span>
      </Box>
    </Menu>
  );

  return (
    <>
      <Button
        edge="end"
        aria-label="account of current user"
        aria-controls={menuId}
        aria-haspopup="true"
        onClick={handleProfileMenuOpen}
        color="inherit"
        classes={{
          label: classes.buttonLabel,
          root: classes.buttonRoot,
        }}
        data-testid="user-dropdown-button" 
      >
        {props.authState?.photo ?
          <Box>
            <Avatar
              alt="..."
              src={props.authState.photo}
              classes={{
                root: classes.avatarRoot + " " + classes.iconButtonOutlined,
              }}
              style={{padding: "0px"}}
            />
          </Box>
          :
          <Box
            component={Avatar}
            marginRight="1rem"
            alt="..."
            classes={{ root: classes.avatarRoot + " " + classes.iconButtonOutlined}}
          > {getNameInitials(getUserFullName())}</Box>
        }
        <Hidden smDown>
          <div style={{color: theme.palette.gray[900]}}>
            {getUserFullName()}
          </div>
        </Hidden>
        <ExpandMoreIcon style={{marginLeft: "5px"}}/>
      </Button>
      {renderMenu}
    </>
  );
}
const mapStateToProps = (state) => ({ ...state });

const mapDispatchToProps = (dispatch) => ({
  logoutAction: () => dispatch(logoutAction()),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserDropdown);
